import React, { Component } from "react";
import "./App.scss";
import AppRouter from "./routers/AppRouter";
import firebase from "firebase";
import { AuthProvider } from "./Auth";
import AudioContextProvider from "./contexts/AudioContext";
import { compose, lifecycle, withHandlers, withState } from "recompose";
import app from "./base";

const registerPushListener = (pushNotification) =>
  navigator.serviceWorker.addEventListener("message", ({ data }) => {
    pushNotification("My Notification");
  });

class App extends Component {
  render() {
    return (
      <AuthProvider>
        <AudioContextProvider>
          <div className="App">
            <div className="App-body">
              <AppRouter />
            </div>
          </div>
        </AudioContextProvider>
      </AuthProvider>
    );
  }
}

export default compose(
  withState("token", "setToken", ""),
  withState("notifications", "setNotifications", []),
  withHandlers({
    pushNotification: ({ setNotifications, notifications }) => (
      newNotification
    ) => setNotifications(notifications.concat(newNotification)),
  }),
  lifecycle({
    async componentDidMount() {
      const { pushNotification, setToken } = this.props;
      if (firebase.messaging.isSupported()) {
        const messaging = app.messaging();
        messaging.usePublicVapidKey(
          // Project Settings => Cloud Messaging => Web Push certificates
          "BD0njedR4968Lb_JUHygSD81WbyyVR3CZ4UccfgjZK6ho3Ny6kXC1hfCyo9oGdeF9Ftzv42AykE0WqpmN8kyVm8"
        );
        messaging
          .requestPermission()
          .then(async function () {
            const token = await messaging.getToken();
            localStorage.setItem("token", token);
            setToken(token);
          })
          .catch(function (err) {
            console.log("Unable to get permission to notify.", err);
          });

        registerPushListener(pushNotification);
      }
    },
  })
)(App);
